import React from "react";
import "./styles/ProjectReleasedTextTabs.scss";

const ProjectReleasedTextTabs = (props) => {
  const {
    contentType,
    currentTab,
    setCurrentTab,
    isMaterial,
    hasAddenda,
  } = props;

  return (
    <div className="tabs">
      {(contentType === "Dramaturgia" || contentType === "Variedades") && (
        <>
          {!isMaterial && (
            <span
              className={`tab ${currentTab === "Capítulos/Sinopse" ? "active" : ""}`}
              onClick={() => setCurrentTab("Capítulos/Sinopse")}
            >
              Capítulos/Sinopse
            </span>
          )}

          {isMaterial && (
            <span
              className={`tab ${currentTab === "Materiais" ? "active" : ""}`}
              onClick={() => setCurrentTab("Materiais")}
            >
              Materiais
            </span>
          )}

          {hasAddenda && (
            <span
              className={`tab ${currentTab === "Adendos" ? "active" : ""}`}
              onClick={() => setCurrentTab("Adendos")}
            >
              Adendos
            </span>
          )}

          <span
            className={`tab ${currentTab === "Outros" ? "active" : ""}`}
            onClick={() => setCurrentTab("Outros")}
          >
            Outros Anexos
          </span>
        </>
      )}
    </div>
  );
};

export default ProjectReleasedTextTabs;
